export const GET_ALL_APP_LIBRARY = 'GET_ALL_APP_LIBRARY';
export const GET_ALL_APP_LIBRARY_LOADING = 'GET_ALL_APP_LIBRARY_LOADING';
export const SET_APP_LIBRARY_COUNT = 'SET_APP_LIBRARY_COUNT';
export const GET_APP = 'GET_APP';
export const SET_APP = 'SET_APP';
export const ADD_APP_FINISHED = 'ADD_APP_FINISHED';
export const SET_APPLICATION_CERTIFICATE = 'SET_APPLICATION_CERTIFICATE';
export const GET_GROUPS_APP_DETAIL = 'GET_GROUPS_APP_DETAIL';
